import { ChevronDown } from 'lucide-react';

const cyclingWords = ['Thinks.', 'Scales.', 'Decides.', 'Transforms.', 'Thinks.'];

export default function HeroSection() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[100svh] flex items-center justify-center bg-[#0D1321] overflow-hidden"
    >
      {/* Circuit Board Texture Overlay */}
      <img
        src="https://static.prod-images.emergentagent.com/jobs/651541d7-5e6b-42ae-bbbb-a15776d2b14a/images/e4999b22e6e96b63f63379e586d4e089214cb10290beac1b50287d8c22ef2507.png"
        alt=""
        className="circuit-overlay"
        aria-hidden="true"
      />

      {/* Floating Orbs */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-[#193E82]/30 rounded-full blur-[60px] sm:blur-[100px] floating-orb" />
      <div className="absolute bottom-1/4 right-1/4 w-56 h-56 sm:w-80 sm:h-80 bg-[#F5A623]/20 rounded-full blur-[60px] sm:blur-[100px] floating-orb-delayed" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <div className="animate-fade-in-up">
          {/* Overline */}
          <p className="text-[#F5A623] text-xs tracking-[0.2em] uppercase font-semibold mb-6">
            IT Solutions & Software Development
          </p>

          {/* Main Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-7xl tracking-tighter font-extrabold leading-[1.1] text-white mb-6">
            We Build Software That{' '}
            <span className="word-cycle-container">
              <span className="word-cycle-list">
                {cyclingWords.map((word, index) => (
                  <span key={index} className="word-cycle-item">
                    {word}
                  </span>
                ))}
              </span>
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl leading-relaxed text-white/70 max-w-3xl mx-auto mb-10 animate-fade-in-up animate-delay-200">
            HireSphere is an IT solutions provider delivering AI-powered platforms,
            custom software, and digital transformation for forward-looking organisations.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animate-delay-300">
            <a
              href="#solutions"
              data-testid="hero-cta-solutions"
              className="btn-primary rounded-full px-8 py-4 text-base font-semibold"
            >
              Explore Our Solutions
            </a>
            <a
              href="#clients"
              data-testid="hero-cta-work"
              className="btn-ghost rounded-full px-8 py-4 text-base font-semibold"
            >
              View Our Work
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - anchored to section bottom, desktop only */}
      <div className="hidden sm:block absolute bottom-10 left-1/2 -translate-x-1/2 scroll-indicator z-10">
        <a href="#marquee" aria-label="Scroll down">
          <ChevronDown className="w-8 h-8 text-white/50" />
        </a>
      </div>
    </section>
  );
}
